function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { map, Observable, tap } from 'rxjs';
import { InjectableServices } from '../enums';
import { MfaFlows, MfaTypes } from '../models/user/mfa';
import { MfaStore } from '../store';
import { WindowedObservable } from '../windowed-observable';
import { AuthService } from './auth.service';
import { BaseConfigService } from './base-config.service';
import { UserService } from './user.service';
export var MfaService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(MfaService, BaseConfigService);
    function MfaService() {
        _class_call_check(this, MfaService);
        var _this;
        _this = _call_super(this, MfaService, arguments), _define_property(_this, "authService", AuthService.getOrCreate()), _define_property(_this, "userService", UserService.getOrCreate()), _define_property(_this, "mfaStore", MfaStore.getOrCreate());
        return _this;
    }
    _create_class(MfaService, [
        {
            key: "resetMfaSettings",
            value: function resetMfaSettings() {
                this.mfaStore.mfaSettingsReset();
                this.authService.setIsMfaCodeRequested(false);
            }
        },
        {
            key: "updateMfaDetails",
            value: function updateMfaDetails(mfaDetails) {
                var _mfaDetails_find;
                var phoneNumber = mfaDetails === null || mfaDetails === void 0 ? void 0 : (_mfaDetails_find = mfaDetails.find(function(item) {
                    return item.phoneNumber;
                })) === null || _mfaDetails_find === void 0 ? void 0 : _mfaDetails_find.phoneNumber;
                this.mfaStore.dispatch({
                    userMfaDetails: mfaDetails
                });
                if (phoneNumber) this.mfaStore.dispatch({
                    userMfaPhoneNumber: phoneNumber
                });
            }
        },
        {
            key: "updateUserMfaDetails",
            value: function updateUserMfaDetails(param) {
                var _this = this;
                var userId = param.userId, payload = param.payload;
                var url = "".concat(this.environment.AUTH_API_URL, "/User/").concat(userId, "/MFA");
                return this.axios.put(url, payload).pipe(tap(function(param) {
                    var data = param.data;
                    if (_this.userService) {
                        _this.userService.userStore.dispatch({
                            userProfile: data
                        });
                    }
                    _this.mfaStore.dispatch({
                        userMfaDetails: data.mfaDetails
                    });
                }), map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "handleSelectMfaType",
            value: function handleSelectMfaType(param) {
                var _this = this;
                var currentCognitoUser = param.currentCognitoUser, currentCognitoUserEmail = param.currentCognitoUserEmail, mfaType = param.mfaType;
                return new Observable(function(observer) {
                    if (!currentCognitoUser) {
                        observer.error('No currentCognitoUser');
                        return;
                    }
                    _this.mfaStore.dispatch({
                        mfaType: mfaType
                    });
                    var mfaTypeCognito = mfaType.toLowerCase() === MfaTypes.SMS.toLowerCase() ? 'SMS_MFA' : 'SOFTWARE_TOKEN_MFA';
                    currentCognitoUser.sendMFASelectionAnswer(mfaTypeCognito, {
                        onSuccess: function(session) {
                            return _this.authService.handleCognitoUserOnSuccess({
                                cognitoSession: session,
                                username: currentCognitoUserEmail,
                                sendGtmEvent: false,
                                observer: observer
                            });
                        },
                        onFailure: function(error) {
                            return _this.authService.handleCognitoUserOnFailure({
                                username: currentCognitoUserEmail,
                                error: error,
                                observer: observer
                            });
                        },
                        mfaRequired: function() {
                            _this.mfaStore.dispatch({
                                preferredMfaMethod: mfaType
                            });
                            return _this.authService.handleCognitoUserMfaRequired({
                                observer: observer
                            });
                        },
                        totpRequired: function() {
                            _this.mfaStore.dispatch({
                                preferredMfaMethod: mfaType
                            });
                            return _this.authService.handleCognitoUserTotpRequired({
                                observer: observer
                            });
                        }
                    });
                });
            }
        },
        {
            // Used to enable/disabled MFA
            key: "handleSetUserMfaPreference",
            value: function handleSetUserMfaPreference(param) {
                var _this = this;
                var currentCognitoUser = param.currentCognitoUser, userId = param.userId, recaptchaToken = param.recaptchaToken, phoneNumber = param.phoneNumber, _param_isEnabled = param.isEnabled, isEnabled = _param_isEnabled === void 0 ? true : _param_isEnabled, mfaMethodRequested = param.mfaMethodRequested;
                return new Observable(function(observer) {
                    var cognitoMfaSettings = {
                        sms: {
                            PreferredMfa: false,
                            Enabled: false
                        },
                        totp: {
                            PreferredMfa: false,
                            Enabled: false
                        }
                    };
                    var mfaSettings = structuredClone(_this.mfaStore.userMfaDetails) || [];
                    var updateMfaSettings = function() {
                        var hasMfaMethodRequested = mfaSettings.some(function(item) {
                            var _item_type;
                            return ((_item_type = item.type) === null || _item_type === void 0 ? void 0 : _item_type.toLowerCase()) === (mfaMethodRequested === null || mfaMethodRequested === void 0 ? void 0 : mfaMethodRequested.toLowerCase());
                        });
                        if (mfaSettings.length > 0 && hasMfaMethodRequested && mfaMethodRequested) mfaSettings = mfaSettings.map(function(settings) {
                            if (settings.type.toLowerCase() === mfaMethodRequested.toLowerCase()) {
                                var _settings_type;
                                return _object_spread(_object_spread_props(_object_spread({}, settings), {
                                    isEnabled: isEnabled
                                }), ((_settings_type = settings.type) === null || _settings_type === void 0 ? void 0 : _settings_type.toLowerCase()) === MfaTypes.SMS.toLowerCase() && phoneNumber && {
                                    phoneNumber: phoneNumber
                                });
                            }
                            return _object_spread({}, settings);
                        }) || [];
                        else if (mfaMethodRequested) {
                            mfaSettings = _to_consumable_array(mfaSettings).concat([
                                _object_spread({
                                    type: mfaMethodRequested,
                                    isEnabled: true,
                                    isPreferred: true
                                }, (mfaMethodRequested === null || mfaMethodRequested === void 0 ? void 0 : mfaMethodRequested.toLowerCase()) === MfaTypes.SMS.toLowerCase() && phoneNumber && {
                                    phoneNumber: phoneNumber
                                })
                            ]);
                        } else {
                            mfaSettings = [];
                        }
                        var isAuthenticatorEnabled = mfaSettings.some(function(item) {
                            return item.type === MfaTypes.Authenticator && item.isEnabled;
                        });
                        // When both SMS and Authenticator App are enabled, Authenticator is the preferred method
                        // isPreferred: setHasPreferred(mfaMethodRequested, isEnabled),
                        mfaSettings = mfaSettings.map(function(item) {
                            var _item_type, _item_type1, _item_type2;
                            if (isAuthenticatorEnabled && ((_item_type = item.type) === null || _item_type === void 0 ? void 0 : _item_type.toLowerCase()) === MfaTypes.Authenticator.toLowerCase() || !isAuthenticatorEnabled && ((_item_type1 = item.type) === null || _item_type1 === void 0 ? void 0 : _item_type1.toLowerCase()) === MfaTypes.SMS.toLowerCase() && item.isEnabled) {
                                var _item_type3;
                                cognitoMfaSettings[(_item_type3 = item.type) === null || _item_type3 === void 0 ? void 0 : _item_type3.toLowerCase()].Enabled = true;
                                return _object_spread_props(_object_spread({}, item), {
                                    isPreferred: true
                                });
                            }
                            cognitoMfaSettings[(_item_type2 = item.type) === null || _item_type2 === void 0 ? void 0 : _item_type2.toLowerCase()].Enabled = item.isEnabled;
                            return _object_spread_props(_object_spread({}, item), {
                                isPreferred: false
                            });
                        });
                    };
                    updateMfaSettings();
                    currentCognitoUser.setUserMfaPreference(cognitoMfaSettings.sms, cognitoMfaSettings.totp, function(err) {
                        if (err) {
                            observer.error(err);
                            return;
                        }
                        var payload = {
                            recaptchaToken: recaptchaToken,
                            mfaDetails: mfaSettings
                        };
                        if (userId) _this.updateUserMfaDetails({
                            userId: userId,
                            payload: payload
                        }).pipe(tap(function(data) {
                            var isMfaEnabled = data.mfaDetails.some(function(item) {
                                return item.isPreferred;
                            });
                            _this.authService.updateCurrentUserMfaStatus(isMfaEnabled);
                        })).subscribe({
                            complete: function() {
                                if (!isEnabled) _this.mfaStore.dispatch({
                                    mfaFlow: MfaFlows.Disable
                                });
                                _this.mfaStore.dispatch({
                                    isUserMfaSettingsUpdated: true
                                });
                                if (_this.mfaStore.mfaType) {
                                    observer.next({
                                        isCodeValid: true,
                                        hasCodeExpired: false
                                    });
                                }
                                observer.complete();
                            },
                            error: function() {
                                observer.error(err);
                            }
                        });
                    });
                });
            }
        },
        {
            key: "handleVerifySoftwareToken",
            value: function handleVerifySoftwareToken(param) {
                var currentCognitoUser = param.currentCognitoUser, code = param.code, deviceName = param.deviceName, recaptchaToken = param.recaptchaToken;
                return new Observable(function(observer) {
                    if (currentCognitoUser) {
                        currentCognitoUser.verifySoftwareToken(code, deviceName, {
                            onSuccess: function() {
                                observer.next({
                                    recaptchaToken: recaptchaToken
                                });
                                observer.complete();
                            },
                            onFailure: function(err) {
                                observer.error(err);
                            }
                        });
                    }
                });
            }
        },
        {
            key: "handleAssociateSoftwareToken",
            value: function handleAssociateSoftwareToken(param) {
                var currentCognitoUser = param.currentCognitoUser;
                return new Observable(function(observer) {
                    currentCognitoUser === null || currentCognitoUser === void 0 ? void 0 : currentCognitoUser.associateSoftwareToken({
                        associateSecretCode: function(secretCode) {
                            observer.next(secretCode);
                            observer.complete();
                        },
                        onFailure: function(error) {
                            observer.error(error);
                        }
                    });
                });
            }
        },
        {
            key: "handleSendMfaCode",
            value: function handleSendMfaCode(param) {
                var _this = this;
                var currentCognitoUser = param.currentCognitoUser, code = param.code, currentCognitoUserEmail = param.currentCognitoUserEmail;
                return new Observable(function(observer) {
                    var _this_mfaStore_mfaType, _MfaTypes_Authenticator;
                    currentCognitoUser === null || currentCognitoUser === void 0 ? void 0 : currentCognitoUser.sendMFACode(code, {
                        onSuccess: function(session) {
                            observer.next({
                                isCodeValid: true,
                                hasCodeExpired: false
                            });
                            _this.mfaStore.dispatch({
                                isCognitoUserValid: true
                            });
                            _this.authService.setIsMfaCodeRequested(false);
                            _this.mfaStore.resetMfaType();
                            return _this.authService.handleCognitoUserOnSuccess({
                                cognitoSession: session,
                                username: currentCognitoUserEmail,
                                sendGtmEvent: false,
                                observer: observer
                            });
                        },
                        onFailure: function(error) {
                            observer.next({
                                isCodeValid: false,
                                hasCodeExpired: false
                            });
                            return _this.authService.handleCognitoUserOnFailure({
                                username: currentCognitoUserEmail,
                                error: error,
                                observer: observer
                            });
                        }
                    }, ((_this_mfaStore_mfaType = _this.mfaStore.mfaType) === null || _this_mfaStore_mfaType === void 0 ? void 0 : _this_mfaStore_mfaType.toLowerCase()) === ((_MfaTypes_Authenticator = MfaTypes.Authenticator) === null || _MfaTypes_Authenticator === void 0 ? void 0 : _MfaTypes_Authenticator.toLowerCase()) ? 'SOFTWARE_TOKEN_MFA' : 'SMS_MFA');
                });
            }
        },
        {
            key: "getPreferredMfaMethod",
            value: function getPreferredMfaMethod(email) {
                var _this = this;
                var url = "".concat(this.environment.AUTH_API_URL, "/User/preferred-mfa?").concat(new URLSearchParams({
                    email: email
                }));
                return this.axios.get(url).pipe(tap(function(param) {
                    var data = param.data;
                    _this.mfaStore.dispatch({
                        preferredMfaMethod: data
                    });
                }), map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.MfaService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new MfaService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return MfaService;
}(BaseConfigService);
